export default __webpack_public_path__ + "static/media/yetumhari.7cea3ba3.jpg";